<template>
  <!-- Contenedor -->
  <div>
    <!-- Introducción al contenido de la pagina -->
    <div class="card-header">
      <h4>Objetivos y tareas</h4>
      <p style="color: darkgray; margin-bottom: 30px">
        Reporte donde se puede ver los objetivos y tareas de un
        <span class="text-success">paciente</span>.
      </p>
    </div>

    <!-- Filtros -->
    <div class="card-content">
      <!-- <div class="row">
        <div
          class="col-md-3"
          v-if="rol == 1 || rol == 20 || rol == 23 || rol == 19"
        >
          <label for="">Sede:</label>
          <select
            class="form-control"
            v-model="sede"
            @change="cambiarSede()"
            style="background-color: white"
          >
            <option
              v-for="sede in SedesProgramacion"
              :key="sede.sede"
              :value="sede.sede"
            >
              {{ sede.sede }}
            </option>
          </select>
          <br />
        </div>
      </div> -->
      <div class="row">
        <!-- Selección de paciente -->
        <div class="col-md-3">
          <label for="type_report">Seleccione el Paciente</label>
          <select
            v-model="value"
            id="type_report"
            class="form-control"
            v-if="type_report == 'paciente'"
            style="background-color: white"
          >
            <option value="todos" selected>Todos...</option>
            <option
              :value="paciente.id"
              v-for="paciente in listPacientes"
              :key="paciente.id"
            >
              {{ paciente.apellidos }} {{ paciente.nombres }}
            </option>
          </select>
        </div>

        <div class="col-md-3">
          <label for="type_report">Seleccione el periodo</label>
          <select
            v-model="periodo"
            id="type_report"
            class="form-control"
            v-if="type_report == 'paciente'"
            style="background-color: white"
          >
            <option
              v-for="periodo in optionPeriods"
              :value="periodo"
              :key="periodo.label"
            >
              {{ periodo.label }}
            </option>
          </select>
        </div>

        <div class="col-md-3">
          <label for="type_report">Seleccione el año</label>
          <input
            type="number"
            id="year"
            v-model="year"
            style="background-color: white"
            name="year"
            min="2025"
            :max="currentYear"
            step="1"
            placeholder="Año"
            class="form-control"
          />
        </div>

        <!-- Botón de búsqueda -->
        <div class="col-md-3" style="margin-top: 25px">
          <button
            class="btn btn-success btn-block btn-fill"
            @click="getObjetives()"
            style="border-radius: 5px"
          >
            Buscar
          </button>
        </div>
        <div></div>
      </div>
    </div>
    <br />

    <!-- Tabla -->
    <div class="card">
      <div class="card-content">
        <div class="row">
          <div class="col-md-12">
            <label for="" style="color: white">fff</label> <br />
            <download-excel
              class="btn btn-secondary btn-fill"
              :data="json_data"
              :fields="json_fields"
              worksheet="Objetivos y logros"
              name="Reporte de objetivos"
              v-if="json_data != ''"
            >
              Exportar todos <i color="black" class="fa fa-download"></i>
            </download-excel>
          </div>
        </div>
        <br />

        <!-- Selección del paginados -->
        <div class="row" style="padding-left: 15px" v-if="queriedData2 != ''">
          <div class="col-3">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
        </div>

        <!-- Contenido -->
        <div class="row">
          <br />
          <!-- Contenido por defecto -->
          <div class="col-md-12" v-if="queriedData2 == ''">
            <center>
              <img
                src="/static/img/ICONOS/estadisticas.svg"
                alt="Imagen de datos vacíos"
                width="70"
              />
              <p class="titulo-mensaje">Aún no hay datos para mostrar.</p>
            </center>
          </div>

          <!-- Contenido de la tabla -->
          <div class="col-md-12" ref="component" v-if="queriedData2 != ''">
            <div>
              <!-- <span style="color:darkgray; margin-bottom: 20px;"> {{ queriedData2.length }} registros </span> -->

              <el-table
                class="table-condensed table-responsive"
                :data="queriedData"
                border
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                >
                  <template #default="{ row }">
                    <span
                      ><center>{{ row[column.prop] }}</center></span
                    >
                  </template>
                </el-table-column>

                <el-table-column label="Tareas" min-width="1000">
                  <template #default="{ row }">
                    <table
                      class="table table-condensed table-responsive"
                      style="border-radius: 8px"
                    >
                      <tr>
                        <th style="max-width: 500px"><center>Tarea</center></th>
                        <th><center>Calificación</center></th>
                      </tr>
                      <tr v-for="tarea in row.tareas" :key="tarea.description">
                        <td
                          style="
                            align-items: center;
                            min-width: 500px;
                            max-width: 500px;
                          "
                        >
                          <center>
                            {{ tarea.description }}
                          </center>
                        </td>
                        <td>
                          <center>
                            <p
                              v-if="tarea.calificaciones[0] == 'Pendiente evaluar'"
                            >
                              <span>Pendiente evaluación</span>
                            </p>
                            <p v-else>{{ tarea.calificaciones[0] }}%</p>
                          </center>
                        </td>
                      </tr>
                    </table>
                  </template>
                </el-table-column>
                <el-table-column width="120" label="Exportar" fixed="right">
                  <template slot-scope="props">
                    <center>
                      <button
                        class="btn btn-fill btn-sm btn-success"
                        title="Exportar a PDF"
                        style="border-radius: 5px"
                        @click="abrirSeleccionarPeriodo(props.row)"
                      >
                        <i class="ti-file"></i> Exportar
                      </button>
                    </center>
                  </template>
                </el-table-column>

                <!-- <el-table-column
                    v-for="column in tableColumnsTask"
                    :key="column.label"
                    :min-width="column.minWidth"
                    :prop="column.prop"
                    :label="column.label"
                  >
                    <template #default="{ row }">
                      <div>
                        <span>{{ row.tareas[0][column.prop] }}</span>
                      </div>
                      <div>
                        <span>{{ row.tareas[1][column.prop] }}</span>
                      </div>
                      <div>
                        <span>{{ row.tareas[2][column.prop] }}</span>
                      </div>
                    </template>
                  </el-table-column> -->
              </el-table>
            </div>
          </div>
        </div>

        <!-- Pie de pagina del paginado -->
        <div class="row" v-if="queriedData2 != ''">
          <div class="col-sm-6 pagination-info">
            <br />
            <p class="category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            ></p-pagination>
          </div>
        </div>
      </div>
      <modal name="seleccionarPeriodo">
        <div class="card-header">
          <h4>
            Selecciona el periodo de evaluación que quieres visualizar en el
            reporte
          </h4>
        </div>
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <label for="periodo">Selecciona el periodo</label>
              <select
                class="form-control"
                id="periodo"
                v-model="periodoVisualizacion"
              >
                <option value="all">Todos los periodos de evaluación</option>
                <option value="1">Periodo 1 de evaluación</option>
                <option value="2">Periodo 2 de evaluación</option>
                <option value="3">Periodo 3 de evaluación</option>
              </select>
            </div>
            <div class="col-md-12">
              <br />
              <br />
              <center>
                <button
                  class="btn btn-danger"
                  style="border-radius: 7px"
                  @click="cerrarSeleccionarPeriodo()"
                >
                  Cancelar
                </button>
                <button
                  class="btn btn-success btn-fill"
                  style="border-radius: 7px"
                  @click="generarPDF(objetivoSeleccionado)"
                >
                  Imprimir informe
                </button>
              </center>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
  
  <script>
import Vue from "vue";
import axios from "axios";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import crearAlerta from "../../global-services/crearAlerta";

import { jsPDF } from "jspdf";
import "jspdf-autotable";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);

export default {
  computed: {
    pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      let result = this.queriedData2.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    },
  },

  data: () => ({
    ip: "https://avanti-erp.com/",
    type_report: "paciente",
    searchQuery: "",
    sede: localStorage.getItem("sede"),
    rol: localStorage.getItem("rol"),
    logo: "",
    SedesProgramacion: [],
    firma: "",
    value: "todos",
    listPacientes: [],
    listTerapeutas: [],
    initialDate: "",
    endDate: "",
    queriedData2: [],
    tableColumns: [
      {
        prop: "paciente", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Paciente", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 250, //ANCHO DE LA COLUMNA
      },
      {
        prop: "fecha", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Fecha", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 120, //ANCHO DE LA COLUMNA
      },
      {
        prop: "fechaLimite",
        label: "Fecha limite",
        minWidth: 120,
      },
      {
        prop: "terapeuta",
        label: "Terapeuta",
        minWidth: 150,
      },
      {
        prop: "objetivo",
        label: "Objetivo",
        minWidth: 300,
      },
      {
        prop: "comentario",
        label: "Comentario del objetivo",
        minWidth: 300,
      },
      {
        prop: "porcentaje",
        label: "% general de avance",
        minWidth: 200,
      },
    ],
    tableColumnsTask: [
      {
        prop: "descripcion", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
        label: "Tareas", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
        minWidth: 200, //ANCHO DE LA COLUMNA
      },
      {
        prop: "porcentaje",
        label: "%",
        minWidth: 30,
      },
      {
        prop: "cumplido",
        label: "Cumplido",
        minWidth: 40,
      },
    ],
    // add this
    periodoVisualizacion: "all",
    pagination: {
      perPage: 25,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50, 100, 200, 300],
      total: 0,
    },
    optionPeriods: [
      { label: "Primer trimestre", valueInitial: "01-01", valueFinal: "03-30" },
      {
        label: "Segundo trimestre",
        valueInitial: "04-01",
        valueFinal: "06-31",
      },
      { label: "Tercer trimestre", valueInitial: "07-01", valueFinal: "09-30" },
      { label: "Cuarto trimestre", valueInitial: "10-01", valueFinal: "12-31" },
    ],
    periodo: "",
    year: "",
    currentYear: new Date().getFullYear(),
    json_fields: {
        "Paciente": "paciente",
        "Terapeuta": "terapeuta",
        "Fecha del objetivo" : "fecha",
        "Objetivo": "objetivo",
        "Logro" : "comentario",
        "Tarea1": "tarea1",
        "Primera evaluación": "calificacion1",
        "Tarea2": "tarea2",
        "Segunda evaluación": "calificacion2",
        "Tarea3": "tarea3",
        "Tercera evaluación": "calificacion3",
    },
    json_data: [],
    objetivoSeleccionado: [],
    mesVisualizacion: {
      "Primer trimestre": {
        1: "Enero",
        2: "Febrero",
        3: "Marzo",
      },
      "Segundo trimestre": {
        1: "Abril",
        2: "Mayo",
        3: "Junio",
      },
      "Tercer trimestre": {
        1: "Julio",
        2: "Agosto",
        3: "Septiembre",
      },
      "Cuarto trimestre": {
        1: "Octubre",
        2: "Noviembre",
        3: "Diciembre",
      },
    },
    trimestreVisualizacion: {
      "Primer trimestre": "Ene, Feb, Mar",
      "Segundo trimestre": "Abr, May, Jun",
      "Tercer trimestre": "Jul, Ago, Sep",
      "Cuarto trimestre": "Oct, Nov, Dic",
    },
    tiposDocumento: {
      NUIP: "NUIP",
      "CÉDULA DE CIUDADANIA": "CC",
      PASAPORTE: "PA",
      "TARJETA DE IDENTIDAD": "TI",
      "CEDULA DE EXTRANJERIA": "CE",
      "REGISTRO CIVIL": "RC",
      NIT: "NI",
      RUT: "RUT",
      "PERMISO POR PROTECCIÓN TEMPORAL": "PPT",
    },
  }),

  components: {
    PPagination,
  },

  methods: {
    abrirSeleccionarPeriodo: function (row) {
      this.objetivoSeleccionado = row;
      this.$modal.show("seleccionarPeriodo");
    },
    cerrarSeleccionarPeriodo: function () {
      this.objetivoSeleccionado = [];
      this.$modal.hide("seleccionarPeriodo");
      this.periodoVisualizacion = "all";
    },
    generarPDF: function (objetivo) {
      console.log(objetivo, "dssdsd");
      const doc = new jsPDF();
      const lineHeight = 4;
      const pageHeight = doc.internal.pageSize.height;
      const pageWidth = doc.internal.pageSize.getWidth();
      const anchoTexto = 180;
      const footerHeight = 15;

      let headerHeight = 26;
      let startX = 15;
      let startY = headerHeight + 26;
      let logo = this.logo;
      // let firma = this.firma;

      const addHeader = function (doc, periodoVisualizacion) {
        const pageCount = doc.internal.getNumberOfPages();

        const tableEncabezado = [
          [
            {
              content: "",
              styles: {
                halign: "center",
                fontSize: 10,
                fontStyle: [0, 0, 0],
                fontFamily: "helvetica",
              },
            },
            {
              content: `INFORME ${
                periodoVisualizacion == "all" ? "TRIMESTRAL" : "MENSUAL"
              } DE OBJETIVOS Y LOGROS`,
              styles: {
                halign: "center",
                fontSize: 10,
                fontStyle: "bold",
                textColor: "#302254",
                fontFamily: "helvetica",
              },
            },
            {
              content:
                "Pag " +
                String(doc.internal.getCurrentPageInfo().pageNumber) +
                " de " +
                String(pageCount),
              styles: {
                halign: "center",
                fontSize: 9,
                fontStyle: "bold",
                textColor: "#000000",
                fontFamily: "helvetica",
              },
            },
          ],
        ];

        doc.autoTable({
          startY: 10,
          body: tableEncabezado,
          theme: "grid",
          styles: {
            cellPadding: 0,
            halign: "left",
            valign: "middle",
            lineWidth: 0,
            minCellHeight: 20,
          },
          columnStyles: {
            0: { cellWidth: 50 },
            1: { cellWidth: 90 },
            2: { cellWidth: 40 },
          },
          didDrawPage: function (data) {
            //   doc.addImage(logo, "webp", 30, 7, 30, 30);
          },
        });

        // const tableEncabezado3 = [
        //   [
        //     {
        //       content: "PACA – FO-187",
        //       styles: {
        //         fontSize: 8,
        //         fontStyle: [0, 0, 0],
        //         fontStyle: "bold",
        //         textColor: "#000000",
        //         fontFamily: "helvetica",
        //       },
        //     },
        //     {
        //       content: "Aprobado: 22/06/2023",
        //       styles: {
        //         fontSize: 8,
        //         fontStyle: [0, 0, 0],
        //         fontStyle: "bold",
        //         textColor: "#000000",
        //         fontFamily: "helvetica",
        //       },
        //     },
        //     {
        //       content: "Versión: 02",
        //       styles: {
        //         fontSize: 8,
        //         fontStyle: [0, 0, 0],
        //         fontStyle: "bold",
        //         textColor: "#000000",
        //         fontFamily: "helvetica",
        //       },
        //     },
        //   ],
        // ];

        // doc.autoTable({
        //   startY: 30,
        //   body: tableEncabezado3,
        //   theme: "grid",
        //   styles: {
        //     halign: "center",
        //     cellPadding: 0,
        //     valign: "middle",
        //     lineWidth: 0.5,
        //     minCellHeight: 6,
        //   },
        //   columnStyles: {
        //     0: { cellWidth: 60 },
        //     1: { cellWidth: 60 },
        //     2: { cellWidth: 60 },
        //   },
        // });
      };

      const addFooter = (doc) => {
        const pageSize = doc.internal.pageSize;
        let fechaActual = new Date();
        let fechaTexto = fechaActual.toLocaleDateString();

        doc.setFontSize(9);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100);
        doc.text(`Avanti ERP`, pageWidth / 2, pageHeight - footerHeight + 7, {
          align: "center",
        });

        doc.setFontSize(9);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100);
        doc.text(
          `Fecha impresión: ${fechaTexto}`,
          pageSize.width / 2,
          pageHeight - footerHeight + 10,
          {
            align: "center",
          }
        );
      };

      // const addSignature = (doc, firmas) => {
      //   const imageWidth = 60; // Ancho de la imagen
      //   const imageHeight = 40; // Alto de la imagen
      //   const margin = 5; // Margen entre imágenes y contenido
      //   let yPosition = startY; // Iniciar justo después del encabezado

      //   firmas.forEach(imageData => {
      //     // Calcular posición X centrada para cada imagen
      //     const xPosition = (pageWidth - imageWidth) / 2;

      //     // Verificar si hay suficiente espacio para la imagen en la página actual
      //     if (yPosition + imageHeight + footerHeight > pageHeight) {
      //       doc.addPage(); // Agregar una nueva página
      //       addHeader(doc); // Agregar encabezado en la nueva página
      //       yPosition = headerHeight + 20; // Reiniciar posición Y después del encabezado
      //       addFooter(doc);
      //     }

      //     // Agregar la imagen en la posición calculada
      //     doc.addImage(
      //       imageData,
      //       "PNG",
      //       xPosition,
      //       yPosition,
      //       imageWidth,
      //       imageHeight
      //     );

      //     // Actualizar la posición Y para la siguiente imagen
      //     yPosition += imageHeight + margin;
      //   });
      // };

      const setupPage = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          addHeader(doc, this.periodoVisualizacion);
          addFooter(doc);
        }
      };

      const checkPageSpace = (yPos) => {
        if (yPos + lineHeight >= pageHeight - footerHeight) {
          headerHeight = 40;
          doc.addPage();
          addHeader(doc);
          addFooter(doc);
          startY = headerHeight + 10; // Reset Y position below the header
        }
      };

      // Justificando texto ------------------------------------------------------------------
      function renderJustifiedLine(line, x, y, maxWidth) {
        const newLine = line.replace(/\s+/g, " ");
        const words = newLine.split(" ");
        const wordCount = words.length;

        if (wordCount <= 300) {
          // Si es una sola palabra, solo la imprimimos
          doc.text(line, x, y);
          return;
        }

        // Calcular el ancho de las palabras sin espacios
        const totalWordsWidth = words.reduce((total, word) => {
          return total + doc.getTextWidth(word);
        }, 0);

        // Calcular el espacio entre palabras
        const spaceWidth = (maxWidth - totalWordsWidth) / (wordCount - 1);

        let currentX = x;
        words.forEach((word, index) => {
          doc.text(word, currentX, y);
          if (index < wordCount - 1) {
            currentX += doc.getTextWidth(word) + spaceWidth;
          }
        });
      }

      const renderJustifiedText = (text) => {
        const lines = doc.splitTextToSize(text, anchoTexto);
        lines.forEach((line) => {
          checkPageSpace(startY);
          doc.setFontSize(10);
          doc.setFont("helvetica", "normal");
          doc.setTextColor("#1E201E");
          renderJustifiedLine(line, startX, startY, anchoTexto);
          startY += lineHeight;
        });
      };

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#302254");
      doc.text(
        "DATOS PERSONALES",
        14,
        startY
      );
      startY += 5;

      const tableData = [
        [
          {
            content: "Nombre del paciente:",
            styles: {
              fontSize: 10,
              fontStyle: "bold",
              textColor: "#000000",
            },
          },
          {
            content: objetivo.paciente,
            styles: { fontSize: 10 },
            colSpan: 3,
          },
        ],
        [
          {
            content: "Fecha de nacimiento:",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: objetivo.fechaNacimiento,
            styles: { fontSize: 10 },
          },
          {
            content: "Edad:",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: this.calcularEdad(objetivo.fechaNacimiento),
            styles: { fontSize: 10 },
          },
        ],
        [
          {
            content: "Tipo de identificación:",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: this.tiposDocumento[objetivo.tipoDocumento],
            styles: { fontSize: 10 },
          },
          {
            content: "Número de documento:",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: parseFloat(objetivo.numeroDocumento).toLocaleString(
              "es-ES"
            ),
            styles: { fontSize: 10 },
          },
        ],
        [
          {
            content: "Entidad:",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: objetivo.entidad,
            styles: { fontSize: 10 },
          },
          {
            content: "Mes del reporte:",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: `${this.trimestreVisualizacion[this.periodo.label]}, ${
              this.year
            }`,
            styles: { fontSize: 10 },
          },
        ],
      ];

      const tableData2 = [
        [
          {
            content: "Nombre del paciente:",
            styles: {
              fontSize: 10,
              fontStyle: "bold",
              textColor: "#000000",
            },
          },
          {
            content: objetivo.paciente,
            styles: { fontSize: 10 },
            colSpan: 3,
          },
        ],
        [
          {
            content: "Fecha de nacimiento:",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: objetivo.fechaNacimiento,
            styles: { fontSize: 10 },
          },
          {
            content: "Edad:",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: this.calcularEdad(objetivo.fechaNacimiento),
            styles: { fontSize: 10 },
          },
        ],
        [
          {
            content: "Tipo de identificación:",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: this.tiposDocumento[objetivo.tipoDocumento],
            styles: { fontSize: 10 },
          },
          {
            content: "Número de documento:",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: parseFloat(objetivo.numeroDocumento).toLocaleString(
              "es-ES"
            ),
            styles: { fontSize: 10 },
          },
        ],
        [
          {
            content: "Entidad:",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: objetivo.entidad,
            styles: { fontSize: 10 },
          },
          {
            content: "Mes del reporte:",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: `${
              this.mesVisualizacion[this.periodo.label][
                this.periodoVisualizacion
              ]
            }, ${this.year}`,
            styles: { fontSize: 10 },
          },
        ],
      ];

      doc.autoTable({
        startY: startY,
        theme: "grid",
        body: this.periodoVisualizacion == "all" ? tableData : tableData2,
        margin: { top: headerHeight + 15, bottom: footerHeight + 20 },
        styles: {
          minCellHeight: 10 * 1.15,
          fontSize: 10,
          cellPadding: { top: 2, bottom: 2, left: 2, right: 2 },
          lineWidth: 0.1
        },
        pageBreak: "auto",
      });
      startY = doc.lastAutoTable.finalY + 10;

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#302254");
      doc.text(
        "DATOS DEL OBJETIVO",
        14,
        startY
      );
      startY += 10;

      const tablaObjetivo = [
        [
          {
            content: "Porcentaje general de avance:",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: `${objetivo.porcentaje}%`,
            styles: { fontSize: 10, fontStyle: "bold", textColor: objetivo.porcentaje >= 60 ? "green" : "red" },
          },
          {
            content: "Periodo de evaluación:",
            styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" },
          },
          {
            content: this.periodo.label,
            styles: { fontSize: 10 },
          },
        ],
      ];

    //   doc.autoTable({
    //     startY: startY,
    //     theme: "grid",
    //     body: tablaObjetivo,
    //     margin: { top: headerHeight + 15, bottom: footerHeight + 20 },
    //     styles: {
    //       minCellHeight: 10 * 1.15,
    //       fontSize: 10,
    //       cellPadding: { top: 2, bottom: 2, left: 2, right: 2 },
    //       lineWidth: 0
    //     },
    //     pageBreak: "auto",
    //   });
    //   startY = doc.lastAutoTable.finalY + 8;

      const comentario =
        objetivo && objetivo.comentario ? objetivo.comentario : "";

      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor("#000000");
      doc.text("Objetivo propuesto:", 14, startY);
      startY += 5;

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.setTextColor("#1E201E");
      renderJustifiedText(objetivo.objetivo);
      startY += 5;

      if(comentario != ""){
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.setTextColor("#000000");
        doc.text("Logro del objetivo:", 14, startY);
        startY += 5;

        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.setTextColor("#1E201E");
        renderJustifiedText(comentario);
        startY += 10;
      }

      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor("#000000");
      doc.text("Porcentaje general de avance:", 14, startY);
      startY += 5;

      const porcentaje = objetivo.porcentaje == 0 ? "Pendiente evaluar" : `${objetivo.porcentaje}%`;
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(objetivo.porcentaje >= 60 ? "green" : "red");
      doc.text(`${porcentaje}`, 14, startY);
      startY += 10;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor("#000000");
      doc.text("Periodo de evaluación:", 14, startY);
      startY += 5;

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.setTextColor("#000000");
      doc.text(`${this.periodo.label}`, 14, startY);
      startY += 13;

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#302254");
      doc.text(
        "DATOS DE LAS TAREAS",
        14,
        startY
      );
      startY += 5;

      let tableDataTareas = [];

      const calificacion1 = objetivo.tareas[0].calificaciones[0];
      const calificacion2 = objetivo.tareas[1].calificaciones[0];
      const calificacion3 = objetivo.tareas[2].calificaciones[0];

      if (this.periodoVisualizacion == "all") {
        tableDataTareas = [
          [
            {
              content: objetivo.tareas[0].description,
              styles: { fontSize: 10, fontStyle: "normal" },
            },
            {
              content: `${objetivo.tareas[0].calificaciones[0]}`,
              styles: { fontSize: 10, fontStyle: "bold", textColor: calificacion1 >= 60 ? "green" : "red" },
            },
          ],
          [
            {
              content: objetivo.tareas[1].description,
              styles: { fontSize: 10, fontStyle: "normal" },
            },
            {
              content: `${objetivo.tareas[1].calificaciones[0]}`,
              styles: { fontSize: 10, fontStyle: "bold", textColor: calificacion2 >= 60 ? "green" : "red" },
            },
          ],
          [
            {
              content: objetivo.tareas[2].description,
              styles: { fontSize: 10, fontStyle: "normal" },
            },
            {
              content: `${objetivo.tareas[2].calificaciones[0]}`,
              styles: { fontSize: 10, fontStyle: "bold", textColor: calificacion3 >= 60 ? "green" : "red" },
            },
          ],
        ];
      } else if (this.periodoVisualizacion == 1) {
        tableDataTareas = [
          [
            {
              content: objetivo.tareas[0].description,
              styles: { fontSize: 10, fontStyle: "normal" },
            },
            {
              content: `${objetivo.tareas[0].calificaciones[0]}%`,
              styles: { fontSize: 10, fontStyle: "bold", textColor: calificacion1 >= 60 ? "green" : "red"},
            },
          ],
        ];
      } else if (this.periodoVisualizacion == 2) {
        tableDataTareas = [
          [
            {
              content: objetivo.tareas[1].description,
              styles: { fontSize: 10, fontStyle: "normal" },
            },
            {
              content: `${objetivo.tareas[1].calificaciones[0]}%`,
              styles: { fontSize: 10, fontStyle: "bold", textColor: calificacion2 >= 60 ? "green" : "red" },
            },
          ],
        ];
      } else if (this.periodoVisualizacion == 3) {
        tableDataTareas = [
          [
            {
              content: objetivo.tareas[2].description,
              styles: { fontSize: 10, fontStyle: "normal" },
            },
            {
              content: `${objetivo.tareas[2].calificaciones[0]}%`,
              styles: { fontSize: 10, fontStyle: "bold", textColor: calificacion3 >= 60 ? "green" : "red" },
            },
          ],
        ];
      }

      let tableDataHeader = [];

      if (this.periodoVisualizacion == "all") {
        tableDataHeader = [["Tareas", "Calificación"]];
      } else {
        tableDataHeader = [["Tarea", `Calificación`]];
      }

      doc.autoTable({
        startY: startY,
        theme: "grid",
        head: tableDataHeader,
        headStyles: {
          fillColor: [255, 255, 255], // Color de fondo blanco
          textColor: [0, 0, 0], // Color de texto negro
          fontStyle: "bold",
          halign: "center",
        },
        columnStyles: {
          0: { cellWidth: 107 },
        },
        body: tableDataTareas,
        margin: { top: headerHeight + 15, bottom: footerHeight + 20 },
        styles: {
          minCellHeight: 10 * 1.15,
          fontSize: 10,
          cellPadding: { top: 2, bottom: 2, left: 2, right: 2 },
          halign: "center"
        },
        pageBreak: "auto",
      });
      startY = doc.lastAutoTable.finalY + 10;

      // addSignature(doc, objetivo.firmas);

      setupPage(doc);

      // Guardar el PDF generado
      doc.save(`reporte de objetivos de ${objetivo.paciente}.pdf`);
      this.cerrarSeleccionarPeriodo();
    },

    getObjetives: function () {
      if (this.value == "" || this.periodo == "" || this.yeah == "") {
        this.$notify(
          crearAlerta("danger", "Parametros incompletos para la busqueda")
        );
        return;
      }

      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      // console.log(this.initialDate);
      const fechaInicial = `${this.year}-${this.periodo.valueInitial}`;
      const fechaFinal = `${this.year}-${this.periodo.valueFinal}`;
      const paciente = this.value;
      const BASE_URL = `${this.ip}api/reportes/objetivos-y-logros/${paciente}/${fechaInicial}/${fechaFinal}/${this.sede}`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          const datos = res.data.data.map((element) => ({
            paciente: `${element.apellidoPaciente} ${element.nombrePaciente}`,
            terapeuta: `${element.apellidoTerapeuta} ${element.nombreTerapeuta}`,
            fecha: element.fecha,
            fechaLimite: element.fechaCumplimiento,
            terapeutaUsuario: element.terapeuta,
            objetivo: element.objetivo,
            tareas: element.tareas,
            comentario: element.logroGeneral,
            porcentaje: element.porcentaje,
            numeroDocumento: element.numeroDocumento,
            fechaNacimiento: element.fechaNacimiento,
            tipoDocumento: element.tipoDocumento,
            entidad: element.entidad,
          }));
          this.queriedData2 = datos;
          this.json_data = this.formatedObjetivesV2(datos);
          this.logo = res.data.logo;
          this.$modal.hide("carga");
        })
        .catch((err) => {
          this.$modal.hide("carga");
          console.log(err);
        });
    },
    formatedObjetivesV2: function (datos){
        let dataReturn = [];
        datos.forEach(element => {
            dataReturn.push({
                paciente: element.paciente,
                terapeuta: element.terapeuta,
                fecha: element.fecha,
                fechaLimite: element.fechaLimite,
                objetivo: element.objetivo,
                comentario: element.comentario,
                porcentaje: element.porcentaje,
                tarea1: element.tareas[0].description,
                calificacion1: element.tareas[0].calificaciones[0],
                tarea2: element.tareas[1].description,
                calificacion2: element.tareas[1].calificaciones[0],
                tarea3: element.tareas[2].description,
                calificacion3: element.tareas[2].calificaciones[0],
            })
        });

        console.log(dataReturn, 'Nuevo excel');
        return dataReturn;
    },
    formatedObjetives: function (datos) {
      console.log(datos);
      let datosReturn = [];
      datos.forEach((element) => {
        let tareas = element.tareas;
        tareas.forEach((elementTask) => {
          datosReturn.push({
            description: elementTask.description,
            calificacion1:
              elementTask.calificaciones[0] == "Sin calificar"
                ? "-1"
                : elementTask.calificaciones[0],
            objetivo: element.objetivo,
            paciente: element.paciente,
            terapeuta: element.terapeuta,
          });
        });
      });

      console.log(datosReturn, "datos returned");
      return datosReturn;
    },
    calcularEdad(fecha) {
      var fechaNacimiento = fecha;
      var values = fechaNacimiento.split("-");
      var dia = values[2];
      var mes = values[1];
      var ano = values[0];

      var fecha_hoy = new Date();
      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      // this.fechaIngreso = fechaActual;

      var edad = ahora_ano + 0 - ano;
      if (ahora_mes < mes) {
        edad--;
      }
      if (mes == ahora_mes && ahora_dia < dia) {
        edad--;
      }
      if (edad > 1900) {
        edad -= 1900;
      }

      // calculamos los meses
      var meses = 0;
      if (ahora_mes > mes) meses = ahora_mes - mes;
      if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
      if (ahora_mes == mes && dia > ahora_dia) meses = 11;

      // calculamos los dias
      var dias = 0;
      if (ahora_dia > dia) dias = ahora_dia - dia;
      if (ahora_dia < dia) {
        var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
        var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
      }

      // this.anos = edad;
      // this.meses = meses;
      return `${edad} año(s) y ${meses} mes(es)`;
    },
    getListPacientes: function () {
      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const sede = this.sede;
      const BASE_URL = `${this.ip}api/list-pacientes/${sede}`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          this.$modal.hide("carga");
          this.listPacientes = res.data.data;
        })
        .catch((err) => {
          this.$modal.hide("carga");
          alert(
            "Ocurrió un error al traer los eventos, por favor comunique al administrador. ERROR: " +
              err
          );
          console.log(err);
        });
    },
    selectTerapeutas: function (especialidad) {
      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}api/selectTerapeutasProgramar/${especialidad}`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          this.$modal.hide("carga");
          this.listTerapeutas = res.data.data;
        })
        .catch((err) => {
          this.$modal.hide("carga");
          console.log(err);
        });
    },
    emailsProgramacion: function () {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}api/emailsProgramacion`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          let data = res.data.data;
          this.SedesProgramacion = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cambiarSede: function () {
      this.getListPacientes();
      this.queriedData2 = [];
      this.json_data = [];
    }
  },

  mounted() {
    this.getListPacientes();
    this.selectTerapeutas(1);
    this.emailsProgramacion();
  },
};
</script>
  
  <style>
.grid-container {
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 1fr;
  grid-template-rows: repeat(4, auto);
  gap: 2px;
}

.grid-item {
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cabecera {
  font-size: 20px;
  font-weight: bold;
  color: darkgray;
}
</style>
  


// WEBPACK FOOTER //
// src/components/Reportes/objetivosLogros.vue